<template>
	<div class="infoviewbg">
		<div class="infoviewtop">{{$t('infoview.infoview_1')}}</div>
		<div class="infoviewitem">
			<div :class="tab==1?'infoviewlistact infoviewlist':'infoviewlist'" @click="changebg(1)">
				{{$t('infoview.infoview_2')}}
			</div>
			<div :class="tab==2?'infoviewlistact infoviewlist':'infoviewlist'" @click="changebg(2)">
				{{$t('infoview.infoview_3')}}
			</div>
			<div :class="tab==3?'infoviewlistact infoviewlist':'infoviewlist'" @click="changebg(3)">
				{{$t('infoview.infoview_4')}}
			</div>
			<div :class="tab==4?'infoviewlistact infoviewlist':'infoviewlist'" @click="changebg(4)">
				{{$t('infoview.infoview_5')}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'infoview',
		props: {
			msg: String,
			tabs: {
				default: 1
			}
		},
		data() {
			return {
				tab: 1
			};
		},
		created() {
			this.tab = this.tabs;
		},
		methods: {
			changebg(index) {
				// this.tab = index
				if (index == 1) {

					this.$router.push('/userinfo')
				}
				if (index == 2) {

					this.$router.push('/OrderInfo')
				}
				if (index == 3) {

					this.$router.push('/ModifyPwd')
				}
				if (index == 4) {

					this.$router.push('/Points')
				}


			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@media only screen and (min-width:800px) {
		.infoviewbg {
			width: 27%;
			margin-right: 3%;
			padding-top: 20px;

		}

		.infoviewtop {
			width: 100%;
			line-height: 30px;
			height: 30px;
			background: #000000;
			text-align: center;
			color: #fff;
			font-size: 16px;
			font-family: Roboto-Black, Roboto;
			margin-bottom: 16px;
		}

		.infoviewitem {
			color: #666666;
			display: flex;
			flex-direction: column;
			cursor: pointer;
		}

		.infoviewlist {
			font-size: 16px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			width: 100%;
			height: 45px;
			line-height: 20px;
			margin: 13px 0;
			padding: 5px 0;
			padding-left: 30px;
			box-sizing: border-box;
			border-left: 9px solid #F4F4F4;
			display: flex;
			align-items: center
		}

		/* .infoviewlist:hover{
			border-left: 9px solid #FE9C2C;
			color:#000
		} */
		.infoviewlistact {
			border-left: 9px solid #FE9C2C;
			color: #000
		}
	}

	@media only screen and (max-width:800px) {
		.infoviewbg {
			margin: 0 auto;
			padding-top: 20px;
			width: 100%;
		}

		.infoviewtop {
			width: 100%;
			line-height: 30px;
			height: 30px;
			background: #000000;
			text-align: center;
			color: #fff;
			font-size: 16px;
			font-family: Roboto-Black, Roboto;
			/* margin-bottom: 8px; */
		}

		.infoviewitem {
			color: #666666;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			cursor: pointer;
		}

		.infoviewlist {
			font-size: 10px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			height: 45px;
			line-height: 45px;
			margin: 10px 0;
			/* padding-left: 30px; */
			box-sizing: border-box;
			/* border-left: 9px solid #F4F4F4; */
			border-left: none;
		}

		/* .infoviewlist:hover{
			border-left: 9px solid #FE9C2C;
			color:#000
		} */
		.infoviewlistact {
			border-bottom: 9px solid #FE9C2C;
			color: #000
		}
	}

	@media only screen and (max-width:412px) and (min-width:300px) {
		.infoviewlist {
			font-size: 10px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			height: 45px;
			line-height: 18px;
			margin: 10px 0;
			/* padding-left: 30px; */
			box-sizing: border-box;
			/* border-left: 9px solid #F4F4F4; */
			border-left: none;
		}
	}

	@media only screen and (max-width:800px) and (min-width:680px) {

		.infoviewlist {
			font-size: 16px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			height: 45px;
			line-height: 45px;
			margin: 10px 0;
			/* padding-left: 30px; */
			box-sizing: border-box;
			/* border-left: 9px solid #F4F4F4; */
		}
	}
</style>
